/**
 * Created by xuyq on 2021/3/3.
 */
import {baseProxy,settings} from '@/myops/core'

export default class dataProxy extends baseProxy{
    constructor(request) {
        super(request);
        this.user = null;
        this.permissionIdList=null;
    }
    async login({eid,password}){
        let {data:{code,data:{token}={},msg} = {}} = await this.request({
            url:settings.request.sys_prefix+"/api/auth/login",
            method:"post",
            data:{account:eid,secPwd:password}
        })

        if(code=== 200){
            return token
        } else {
            throw new Error(msg);
        }
    }
    async getUserInfo(){
        let {data:{code,data,msg}} = await this.request({
            url:settings.request.sys_prefix+"api/auth/getNewCurrentAuthUserInfo",
            method: 'get'
        })
        if(code=== 200){
            let sapinfo = data.sapPersonalInfo
            let {permissionList,roles} = this.extractPermission(data.modules)

            sapinfo.fullname = sapinfo.fullLegalName
            sapinfo.eid = sapinfo.enterpriseId
            sapinfo.personnelNumber = sapinfo.employeeId
            this.user = sapinfo
            this.user.roles = roles
            this.user.userExInfo = {}
            this.user.userExInfo.permissionList = permissionList
            return sapinfo
        } else {
            throw new Error(msg);
        }
    }
    extractPermission(modules){
        let permissionList = []
        let roles = []
        for(let key in modules){
            let m = modules[key]
            if(m.permissionIdList && m.permissionIdList.length>0){
                permissionList = permissionList.concat(m.permissionIdList)
            }
            if(m.roleList && m.roleList.length>0){
                roles = roles.concat(m.roleList)
            }
        }
        return {permissionList,roles}
    }
    async getDicByArray(catagroyArray){
        let {data:{code,data,msg}} = await this.request({
            url:settings.request.sys_prefix+"api/manage/dic/getDic",
            params: {dicType: catagroyArray.join(',')},
            method: 'get'
        })
        if(code=== 200){
            return data
        } else {
            throw new Error(msg);
        }
    }
    async getPermission(moduleName){
        let permissionList = (this.user.userExInfo && this.user.userExInfo.permissionList)||[]
        return permissionList.map(t=>{
            return {
                repositoryId:t
            }
        })
    }
}
